import { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { Spinner } from "@chakra-ui/react";
import MyWorkflowDetail from "./MyWorkflowDetail";

const MyWorkflowDetailPage = () => {
  const { productCode } = useParams();
  const navigate = useNavigate();
  const { state } = useLocation();
  const [product, setProduct] = useState(null);
  useEffect(() => {
    setProduct({
      _id: null,
      code: productCode,
      name: "",
      clockId: "",
      dataStandardVersionCode: "",
      description: "",
      routing: {
        signalsEndpoint: "",
        triggersEndpoint: "",
        eventsEndpoint: "",
        productEndpoint: "",
      },
      signalRegister: [],
      triggerRegister: [],
      eventRegister: [],
      roleDefinitions: [],
      activityPatternDefinitions: [],
      tiptapDocumentTemplate: "",
      createdDate: new Date().toISOString(),
      productTemplates: [],
    });
  }, [productCode]);

  if (!product) return <Spinner />;

  const handleClose = () => {
    // Change this to window.history.back()
    window.history.back();
  };

  return (
    <>
      <MyWorkflowDetail
        product={productCode}
        baseUrl="https://workflow.poc.mrc.ai"
      />
    </>
  );
};

export default MyWorkflowDetailPage;
